import {ApolloError} from '@apollo/client'

const actionErrorCode = (e: ApolloError): string | null =>
  e.graphQLErrors?.[0].extensions?.[0].code

const actionErrorData = (e: ApolloError): string | null =>
  e.graphQLErrors?.[0].extensions?.[0].data

export {actionErrorCode, actionErrorData}
